export default __webpack_public_path__ + "static/media/auto-transmission-auto.df5fc904.svg";